/**
 * Where the account corrects: its own speciality, and those an admin granted a MAGE-X reviewer
 * (PT-137). The API sends the session's own list as `writable_specialites`; the sidebar offers
 * exactly these to a reviewer, and outside them a screen is read-only (`useReadonlyScope`).
 *
 * A payload from before the list existed carries `own_specialite` alone, which is the
 * one-speciality answer it always was.
 */
import useUser from "@app/zustand/user";

interface WritableSpecialitesAccount {
  specialite?: string | null;
  own_specialite?: string | null;
  writable_specialites?: string[] | null;
}

export function writableSpecialitesOf(
  account: WritableSpecialitesAccount | null,
): string[] {
  if (!account) return [];
  if (Array.isArray(account.writable_specialites))
    return account.writable_specialites;
  const own = account.own_specialite ?? account.specialite ?? null;
  return own ? [own] : [];
}

export function useWritableSpecialites(): string[] {
  const user = useUser((state) => state.user);
  return writableSpecialitesOf(user as WritableSpecialitesAccount | null);
}
